<template>
    <div>
        <h2>充值类别管理</h2>
        <el-row>
            <el-col :span="4">
                <el-button size="small" @click="addFormVisible = true" style="margin-bottom:10px;">新增</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="foodTypeListData" border stripe style="width: 100%">
                    <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
                    <el-table-column prop="NAME" label="名称" min-width="100"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <div class="block">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                           layout="total,prev, pager, next, jumper" :total="totalNum">
            </el-pagination>
        </div>
        <!-- 新增餐品类别模态框 -->
        <el-dialog title="新增餐品类别" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
            <el-form :model="addForm" ref="addForm" :rules="rules" style="margin-top: 0">
                <el-form-item label="名称：" :label-width="formLabelWidth" prop="MEAL_NAME">
                    <el-input v-model="addForm.MEAL_NAME" auto-complete="off" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close('addForm')">取 消</el-button>
                <el-button @click="submitAdd('addForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { rechargeManage, addRecharge } from '@/api/rechargeApi';

export default {
  data() {
    const name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]$/;
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('内容不能为空');
      } else if (name.test(value)) {
        callback('您输入的格式有误');
      } else {
        callback();
      }
    };
    return {
      // loading:false,
      foodTypeListData: [],
      totalNum: 0,
      typeData: [{ NAME: '支付宝', STATUS: 1 }],
      formLabelWidth: '100px',
      addFormVisible: false,
      pageSize: 10,
      currentPage: 1,
      addForm: {
        MEAL_NAME: '',
      },
      rules: {
        MEAL_NAME: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    // 获取餐品
    queryData() {
      const data = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: 10,
      };
      rechargeManage(data).then((res) => {
        this.foodTypeListData = res.length > 0 ? res[0].OP_ROLE : [];
        this.totalNum = res.length > 0 ? res[0].TOTAL_COUNT : [];
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 新增收入类别
    submitAdd(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          const data = {
            NAME: this.addForm.MEAL_NAME,
          };
          if (!this.addForm.MEAL_NAME) {
            this.$message.show({
              text: '内容不能为空',
              type: 'error',
            });
            document.body.style.cursor = 'default';
            return false;
          }
          addRecharge(data).then((res) => {
            this.$message.show({
              text: '新增成功',
              type: 'success',
            });
            this.queryData();
            this.addFormVisible = false;
            this.$refs[formName].resetFields();
            // this.loading = false
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 关闭弹窗
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
    },
    handleCurrentChange() {
      this.queryData();
    },
  },
  mounted() {
    this.queryData();
  },
};
</script>
<style>
    .block {
        float: right;
    }
</style>




// WEBPACK FOOTER //
// src/components/rechargeManage.vue